import { CampaignsView } from "@/admin/marketing/CampaignsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/campaigns")({
    component: CampaignsView,
});
